import i18next from "i18next";
import ca from "../../locales/ca.json";
import de from "../../locales/de.json";
import el from "../../locales/el.json";
import en from "../../locales/en.json";
import en_US from "../../locales/en_US.json";
import es from "../../locales/es.json";
import es_US from "../../locales/es_US.json";
import eu from "../../locales/eu.json";
import fr from "../../locales/fr.json";
import gl from "../../locales/gl.json";
import it from "../../locales/it.json";
import pt from "../../locales/pt.json";
import sl from "../../locales/sl.json";

import { getCountryLanguage, getCurrentLanguage, getEntryISOLanguagePath, USA_BASEPATH_VARIANTS } from "../BasePathTools";

const i18nextInit = () => {
  i18next.init({
    lng: getCurrentLanguage(),
    interpolation: { escapeValue: false },
    resources: {
      fr: { translation: fr },
      de: { translation: de },
      en: { translation: USA_BASEPATH_VARIANTS.EN.includes(getCountryLanguage()) ? en_US : en },
      ca: { translation: ca },
      el: { translation: el },
      es: { translation: USA_BASEPATH_VARIANTS.ES.includes(getCountryLanguage()) ? es_US : es },
      it: { translation: it },
      eu: { translation: eu },
      gl: { translation: gl },
      pt: { translation: pt },
      sl: { translation: sl },
    },
  });
};

export const initialize = async (): Promise<void> => {
  i18nextInit();
  alignUrl();
};

export const alignUrl = () => {
  const newURL = window.location.href.replace(`${getEntryISOLanguagePath()}`,`${getCountryLanguage()}`);  
  window.history.replaceState(null, null, newURL);
};
